import React, { useState } from "react";
import Styles from "./Heading.module.css"; // Assuming you have a CSS module for styles
import { Add } from "@mui/icons-material";
import ConGenListingModal from "../../Modals/ConGen/ConGenListingModal";
import { createListing } from "../../../Services/BuySell/Creation";
import { useSelector } from "react-redux";

const SelfHeader = () => {
  const user = useSelector((state) => state?.persistedReducer?.userType);
  const listingCount = useSelector(
    (state) => state?.CapacitySlice?.common?.totalElements
  );
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleModalSubmit = async (data) => {
    setLoading(true);
    let res = await createListing(
      data,
      user === "CONSUMER" ? "consumer" : "generator"
    );
    if (res?.data?.code === 200) {
      setOpen(false);
      window.location.reload();
    }
    setLoading(false);
  };

  const handleCreateListing = () => {
    setOpen(true);
  };

  return (
    <>
      {open && (
        <ConGenListingModal
          type="add"
          open={open}
          loading={loading}
          handleClose={() => setOpen(false)}
          handleSubmit={handleModalSubmit}
          handleSubmitLoading={loading}
          setHandleSubmitLoading={setLoading}
        />
      )}
      <div className={`display_flex_row ${Styles.selfHeaderContainer}`}>
        <div className={`display_flex_row_center ${Styles.selfHeaderLeft}`}>
          <span>My Listing:</span>
          <span>{listingCount}</span>
        </div>
        <div
          className={`activeButton_type_2 display_flex_row_center ${Styles.addListingButton}`}
          onClick={handleCreateListing}
        >
          <Add style={{ fontSize: "16px" }} />
          <span>Add Listing</span>
        </div>
      </div>
    </>
  );
};

export default SelfHeader;
